import React, { useEffect, useState } from "react";

import classNames from "classnames";
import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";

import { ReactComponent as IconLink24 } from "../../icons/icon/24/a-icon-link-24.svg";
import {
  ReactComponent as IconFacebookOriginalColored24,
} from "../../icons/logo/social/24/a-logo-facebook-original-colored-24.svg";
import { ReactComponent as IconFacebookWhite24 } from "../../icons/logo/social/24/a-logo-facebook-white-24.svg";
import { ReactComponent as IconLinkedInOriginalColored24 } from "../../icons/logo/social/24/a-logo-linkedin-24.svg";
import { ReactComponent as IconLinkedInWhite24 } from "../../icons/logo/social/24/a-logo-linkedin-white-24.svg";
import { ReactComponent as IconThreads24 } from "../../icons/logo/social/24/a-logo-threads-24.svg";
import { ReactComponent as IconThreadsWhite24 } from "../../icons/logo/social/24/a-logo-threads-white-24.svg";
import { ReactComponent as IconTwitter24 } from "../../icons/logo/social/24/a-logo-twitter-24.svg";
import { ReactComponent as IconTwitterWhite24 } from "../../icons/logo/social/24/a-logo-twitter-white-24.svg";
import { ReactComponent as ShareButtonFacebook } from "../../icons/logo/social/a-share-button-facebook.svg";
import { ReactComponent as ShareButtonLink } from "../../icons/logo/social/a-share-button-link.svg";
import { ReactComponent as ShareButtonLinkedIn } from "../../icons/logo/social/a-share-button-linkedIn.svg";
import { ReactComponent as ShareButtonThreads } from "../../icons/logo/social/a-share-button-threads.svg";
import { ReactComponent as ShareButtonTwitter } from "../../icons/logo/social/a-share-button-twitter.svg";
import CopyToClipboard from "../copyToClipboard/copyToClipboard";

import "./socialMediaShare.scss";

const SocialMediaShare = ({
  facebook = true,
  twitter = true,
  shareUrl = null,
  shareTitle = "DKMS",
  onlyIcon = false,
  copyUrl = false,
  linkedIn = true,
  shareButtons = false,
  followLinks = null,
  white = false,
  className = undefined,
}) => {
  const intl = useIntl();

  if (followLinks) {
    return (
      <div className="social-media-share">
        {!onlyIcon && <FormattedMessage id="socialmedia.follow" />}
        {followLinks.url_facebook.value && (
          <a
            href={followLinks.url_facebook.value}
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
            aria-label={intl.formatMessage({ id: "social_media_share.share_on_facebook" })}
          >
            <IconFacebookOriginalColored24 />
          </a>
        )}
        {followLinks.url_twitter.value && (
          <a
            href={followLinks.url_twitter.value}
            target="_blank"
            rel="noopener noreferrer"
            className="no-style"
            aria-label={intl.formatMessage({ id: "social_media_share.share_on_twitter" })}
          >
            <IconTwitter24 />
          </a>
        )}
      </div>
    );
  }

  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (shareUrl !== null) {
      setUrl(shareUrl);
    } else {
      setUrl(window.location.href);
    }
  }, [shareUrl]);

  return (
    <div className={classNames("social-media-share", { "flex-wrap": shareButtons }, className)}>
      {!onlyIcon && <FormattedMessage id="socialmedia.share" />}
      {facebook && (
        <a
          href={`https://www.facebook.com/sharer.php?u=${url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="no-style"
          aria-label={intl.formatMessage({ id: "social_media_share.share_on_facebook" })}
        >
          {shareButtons
            ? <ShareButtonFacebook />
            : (white && <IconFacebookWhite24 />) || <IconFacebookOriginalColored24 />}
        </a>
      )}
      {twitter && (
        <a
          href={`https://twitter.com/share?source=tweetbutton&text=${shareTitle}&url=${url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="no-style"
          aria-label={intl.formatMessage({ id: "social_media_share.share_on_facebook" })}
        >
          {shareButtons
            ? <ShareButtonTwitter />
            : (white && <IconTwitterWhite24 />) || <IconTwitter24 />}
        </a>
      )}

      {linkedIn && (
        <a
          href={`https://www.linkedin.com/shareArticle?url=${url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="no-style"
          aria-label={intl.formatMessage({ id: "social_media_share.share_on_linkedin" })}
        >
          {shareButtons
            ? <ShareButtonLinkedIn />
            : (white && <IconLinkedInWhite24 />) || <IconLinkedInOriginalColored24 />}
        </a>
      )}
      <a
        href={process.env.GATSBY_THREADS_URL && process.env.GATSBY_THREADS_URL.replace("{url}", url)}
        target="_blank"
        rel="noopener noreferrer"
        className="no-style"
        aria-label={intl.formatMessage({ id: "social_media_share.share_on_threads" })}
      >
        {shareButtons
          ? <ShareButtonThreads />
          : (white && <IconThreadsWhite24 />) || <IconThreads24 />}
      </a>
      {copyUrl && (
        <CopyToClipboard
          textToCopy={url}
          copyText={intl.formatMessage({ id: "socialmedia.copy_link" })}
          copiedText={intl.formatMessage({ id: "socialmedia.link_copied" })}
        >
          {shareButtons ? (
            <ShareButtonLink />
          ) : (
            <IconLink24 />
          )}
        </CopyToClipboard>
      )}
    </div>
  );
};

SocialMediaShare.propTypes = {
  className: PropTypes.string,
  copyUrl: PropTypes.bool,
  facebook: PropTypes.bool,
  followLinks: PropTypes.oneOfType([PropTypes.object]),
  linkedIn: PropTypes.bool,
  onlyIcon: PropTypes.bool,
  shareButtons: PropTypes.bool,
  shareTitle: PropTypes.string,
  shareUrl: PropTypes.string,
  twitter: PropTypes.bool,
  white: PropTypes.bool,
};

export default SocialMediaShare;
